<div class="row justify-content-md-center no-gutters facilitatorSearch">
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 sessionAudienceSection whiteBg padb0 marL10">
                <h5 class="sectionTitleBig" #headerHeight>
                    Facilitator Search<span class="searchDrownArrow" *ngIf="seaerchAreaDownArrow"
                        (click)="searchAreaExpand()">
                        <i class="fa fa-chevron-down"></i>
                    </span><span class="searchDrownArrow" *ngIf="seaerchAreaUpArrow" (click)="searchAreaCollapse()">
                        <i class="fa fa-chevron-up"></i>
                    </span>
                </h5>
                <div [hidden]="!searchAreaFields" #searchFieldsHeight>
                    <div class="row">
                        <div class="col-4">
                            <label for="clientProgram">Is this session for a client?</label>
                            <div class="form-group spacing-info-text">
                                <select class="form-control custom-select" id="clientProgram" [(ngModel)]="userType"
                                    (change)="onUserTypeChange(userType)">
                                    <option value=null selected>Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                            </div>
                        </div>
                        <div class="col-4">
                            <label for="certificationLevelSearch">Business Chemistry Certification Level</label>
                            <div class="info-text">If this is for a client, select client certified</div>
                            <div class="form-group spacing-info-text">
                                <select class="form-control" name="CertificationID" id="certificationLevelSearch"
                                    (ngModelChange)="selectedTopic=null;selectedContentArea=null"
                                    [(ngModel)]="selectedCertificationLevel" (change)="checkDisability()"
                                    (keyup.enter)="onSearchClicked = false;onSearch(1, 'LastName', 'ASC', true)">
                                    <option value=0 selected>Select
                                    </option>
                                    <option value=3>All</option>
                                    <option *ngFor="let certificate of certificationLevelList"
                                        value="{{certificate?.CertificationlevelID}}">
                                        {{certificate?.Certficationlevel}}
                                    </option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="multiSelectDrop">
                                <div class="subTitlesSmall">Country/Location</div>
                                <form [formGroup]="facilitatorSearchForm">
                                    <app-ng-multiselect-dropdown
                                        (onSelect)="onCountrySelect($event);checkDisability();selectChild?.resetPlaceHolder('state');selectChild1.resetPlaceHolder('city');selectChild2.resetPlaceHolder('function');selectChild3.resetPlaceHolder('service');selectChild5.resetPlaceHolder('industry');selectChild6.resetPlaceHolder('sector')"
                                        [placeholder]="countryPlaceholder" name="CountryID" class="multiselectComp"
                                        [settings]="dropdownSettings" [data]="countryList" [(ngModel)]="selectedCountry"
                                        (onSelectAll)="onCountrySelect($event);checkDisability()"
                                        (onDeSelectAll)="onCountrySelect($event);checkDisability()"
                                        (onCancelClick)="clearLevelSearch($event,'country')"
                                        formControlName="CountryID">

                                    </app-ng-multiselect-dropdown>
                                </form>

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="multiSelectDrop">
                                <div class="subTitlesSmall">State</div>
                                <form [formGroup]="facilitatorSearchForm">
                                    <app-ng-multiselect-dropdown #child [disabledropdown]="selectedCountry.length == 0 || disableState"
                                        [placeholder]="statePlaceholder" name="StateID" class="multiselectComp"
                                        [settings]="dropdownSettings" [data]="stateList" [(ngModel)]="selectedState"
                                        (onSelect)="onStateSelect($event);selectChild1.resetPlaceHolder('city');"
                                        (onSelectAll)="onStateSelect($event)" (onDeSelectAll)="onStateSelect($event)"
                                        (onCancelClick)="clearLevelSearch($event,'state')" formControlName="StateID">

                                    </app-ng-multiselect-dropdown>
                                </form>

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="multiSelectDrop">
                                <div class="subTitlesSmall">City</div>
                                <form [formGroup]="facilitatorSearchForm">
                                    <app-ng-multiselect-dropdown #child1 [placeholder]="cityPlaceholder" name="CityID"
                                        class="multiselectComp"
                                        [disabledropdown]="selectedCountry.length == 0 || selectedState.length == 0"
                                        [settings]="CitydropdownSettings" [data]="cityList" [(ngModel)]="selectedCity"
                                        (onSelect)="onCitySelect($event)" (onSelectAll)="onCitySelect($event)"
                                        (onDeSelectAll)="onCitySelect($event)"
                                        (onCancelClick)="clearLevelSearch($event,'city')" formControlName="CityID">

                                    </app-ng-multiselect-dropdown>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="multiSelectDrop">
                                <div class="subTitlesSmall">Experience Level</div>
                                <form [formGroup]="facilitatorSearchForm">
                                    <app-ng-multiselect-dropdown #child7 [placeholder]="'Select'"
                                        name="DeloitteSessionID" class="multiselectComp"
                                        [settings]="FacilitateddropdownSettings" [data]="experinceLevelRange"
                                        [(ngModel)]="selectedExperienceLevelRange" (ngModelChange)="checkDisability()"
                                        (onSelect)="selectedExperienceLevel($event)"
                                        (onSelectAll)="selectedExperienceLevel($event)"
                                        (onDeSelectAll)="selectedExperienceLevel($event)"
                                        (onCancelClick)="clearLevelSearch($event,'experienceLevel')"
                                        formControlName="DeloitteSessionID">

                                    </app-ng-multiselect-dropdown>
                                </form>

                            </div>
                        </div>
                        <div class="col-4">
                            <div class="multiSelectDrop">
                                <div class="subTitlesSmall">Level</div>
                                <form [formGroup]="facilitatorSearchForm">
                                    <app-ng-multiselect-dropdown #child4 [placeholder]="'Select'" name="LevelID"
                                        class="multiselectComp" [settings]="dropdownSettings" [data]="jobLevelList"
                                        [(ngModel)]="selectedJobLevel" (ngModelChange)="checkDisability()"
                                        (onSelect)="onLevelSelect($event)" (onSelectAll)="onLevelSelect($event)"
                                        (onDeSelectAll)="onLevelSelect($event)"
                                        (onCancelClick)="clearLevelSearch($event,'level')" formControlName="LevelID">

                                    </app-ng-multiselect-dropdown>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <label class="subTitlesSmall" for="contentArea">Content Area</label>
                            <div class="form-group">
                                <select id="contentArea" class="form-control custom-select"
                                    (ngModelChange)="selectedTopic=null" [(ngModel)]="selectedContentArea"
                                    [disabled]="selectedCertificationLevel==2||selectedCertificationLevel==0">
                                    <option value=null selected>Select</option>
                                    <option *ngFor="let contentArea of contentAreaList" value="{{contentArea?.ID}}">
                                        {{contentArea?.ContentAreaName}}
                                    </option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                            </div>
                        </div>
                        <div class="col-4">
                            <label class="subTitlesSmall" for="topic">Topic</label>
                            <div class="form-group">
                                <select class="form-control custom-select" id="topic" [(ngModel)]="selectedTopic"
                                    [disabled]="selectedContentArea!=2">
                                    <option value=null selected>Select
                                    </option>
                                    <option *ngFor="let topic of topicList" value="{{topic?.ID}}">
                                        {{topic?.TopicName}}
                                    </option>
                                </select>
                                <i class="fa fa-chevron-down"></i>
                            </div>
                        </div>
                    </div>
                    <div class="panel-group" id="accordion">
                        <div class="panel panel-default">
                            <div class="collapse in show">
                                <div class="panel-body">
                                    <div class="panel panel-default" id="tab1">
                                        <div class="panel-heading advance-search-accordion"
                                            (click)="userRoleService.closeAccordion('#collapse1')">
                                            <h4 class="panel-title" (click)="ScrollIntoView('#tab1')">
                                                <a data-bs-parent="#accordion">Advanced Search</a>
                                            </h4>
                                        </div>
                                        <div id="collapse1" class="panel-collapse collapse accordion1">
                                            <div class="panel-body">
                                                <div id="accordion1" class="col-12 advanced-search">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <div class="multiSelectDrop">
                                                                <div class="subTitlesSmall">Function</div>
                                                                <form [formGroup]="facilitatorSearchForm">
                                                                    <app-ng-multiselect-dropdown #child2
                                                                        [placeholder]="'Select'" name="FunctionID"
                                                                        class="multiselectComp"
                                                                        [disabledropdown]="selectedCountry.length == 0"
                                                                        [settings]="dropdownSettings"
                                                                        [data]="functionList"
                                                                        [(ngModel)]="selectedFunction"
                                                                        (onSelect)="onFunctionSelect($event);selectChild3.resetPlaceHolder('service')"
                                                                        (onSelectAll)="onFunctionSelect($event)"
                                                                        (onDeSelectAll)="onFunctionSelect($event)"
                                                                        (onCancelClick)="clearLevelSearch($event,'function')"
                                                                        formControlName="FunctionID">

                                                                    </app-ng-multiselect-dropdown>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="multiSelectDrop">
                                                                <div class="subTitlesSmall">Service Area</div>
                                                                <form [formGroup]="facilitatorSearchForm">
                                                                    <app-ng-multiselect-dropdown #child3
                                                                        [placeholder]="'Select'" name="ServiceID"
                                                                        class="multiselectComp"
                                                                        [disabledropdown]="selectedCountry.length == 0"
                                                                        [settings]="selectedServicedropdownSettings"
                                                                        [data]="serviceList"
                                                                        [(ngModel)]="selectedService"
                                                                        (onSelect)="onServiceSelect($event)"
                                                                        (onSelectAll)="onServiceSelect($event)"
                                                                        (onDeSelectAll)="onServiceSelect($event)"
                                                                        (onCancelClick)="clearLevelSearch($event,'serviceArea')"
                                                                        formControlName="ServiceID">

                                                                    </app-ng-multiselect-dropdown>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <div class="multiSelectDrop">
                                                                <div class="subTitlesSmall">Industry</div>
                                                                <form [formGroup]="facilitatorSearchForm">
                                                                    <app-ng-multiselect-dropdown #child5
                                                                        [placeholder]="'Select'" name="IndustryID"
                                                                        class="multiselectComp"
                                                                        [disabledropdown]="selectedCountry.length == 0"
                                                                        [settings]="dropdownSettings"
                                                                        [data]="industryList"
                                                                        [(ngModel)]="selectedIndustry"
                                                                        (onSelect)="onIndustrySelect($event);selectChild6.resetPlaceHolder('sector')"
                                                                        (onSelectAll)="onIndustrySelect($event)"
                                                                        (onDeSelectAll)="onIndustrySelect($event)"
                                                                        (onCancelClick)="clearLevelSearch($event,'industry')"
                                                                        formControlName="IndustryID">
                                                                    </app-ng-multiselect-dropdown>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="multiSelectDrop">
                                                                <form [formGroup]="facilitatorSearchForm">
                                                                    <div class="subTitlesSmall">Sector</div>
                                                                    <app-ng-multiselect-dropdown #child6
                                                                        [placeholder]="'Select'" name="SectorID"
                                                                        class="multiselectComp"
                                                                        [disabledropdown]="selectedCountry == 0"
                                                                        [settings]="selectedSectordropdownSettings"
                                                                        [data]="sectorList" [(ngModel)]="selectedSector"
                                                                        (onSelect)="onSectorSelect($event)"
                                                                        (onSelectAll)="onSectorSelect($event)"
                                                                        (onDeSelectAll)="onSectorSelect($event)"
                                                                        (onCancelClick)="clearLevelSearch($event,'sector')"
                                                                        formControlName="SectorID">

                                                                    </app-ng-multiselect-dropdown>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="multiSelectDrop">
                                                              <div class="subTitlesSmall">
                                                                Method of Delivery
                                                                <span class="infoIconSmall-deliveryMethod"
                                                                      title="Filter by their past delivery method: in person, virtual, or hybrid"></span>
                                                              </div>
                                                                <form [formGroup]="facilitatorSearchForm">
                                                                    <app-ng-multiselect-dropdown #child9
                                                                        [placeholder]="'Select'" id="deliveryModelID"
                                                                        name="deliveryModelID" class="multiselectComp"
                                                                        [settings]="DeliveryModeldropdownSettings"
                                                                        [data]="deliveryModelList"
                                                                        [(ngModel)]="selectedDeliveryModel"
                                                                        (onSelect)="onDeliveryModelSelect($event)"
                                                                        (onSelectAll)="onDeliveryModelSelect($event)"
                                                                        (onDeSelectAll)="onDeliveryModelSelect($event)"
                                                                        (onCancelClick)="clearLevelSearch($event,'DeliveryModel')"
                                                                        formControlName="deliveryModelID">

                                                                    </app-ng-multiselect-dropdown>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label class="subTitlesSmall" for="facilitatorNameSearch">Facilitator Name <i>(if
                                                                    known)</i></label><input type="text" placeholder=""
                                                                id="facilitatorNameSearch"
                                                                [(ngModel)]="selectedName"
                                                                (ngModelChange)="checkDisability()"
                                                                (keyup.enter)="onSearchClicked = false;onSearch(1, 'LastName', 'ASC', true)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div>
                    <div class="row separateLineTop horizontalLine">
                        <div class="col text-right">
                            <button *ngIf="totalRecords == 0 || !seaerchAreaDownArrow" type="button" class="clickBtn"
                                (click)="onSearchClicked = false;onSearch(1, 'LastName', 'ASC', true)"
                                [disabled]="disableButtons">
                                Search
                            </button>
                            <button *ngIf="totalRecords > 0 && seaerchAreaDownArrow" type="button" class="clickBtn"
                                (click)="searchAreaExpand()" [disabled]="disableButtons">
                                Modify Search
                            </button>
                            <button type="reset" class="clickBtn marL20" (click)="onClearSelection()"
                                [disabled]="disableButtons">
                                Clear
                            </button>
                        </div>
                    </div>
                </div>

                <div class="requestEmailButton text-right">
                    <div class="maxResultsLabel" *ngIf="showTable">
                        <span class="countLabel">
                            {{totalRecords}}
                            Records
                        </span><br />Maximum of 1000 records will display <br />Maximum of 10 facilitators
                        can be inquired at once
                    </div>
                    <button type="reset" class="clickBtn marL20" (click)="onRequestAvailability()"
                        [disabled]="isRequestorAvailabilityDisabled === true">
                        REQUEST FACILITATOR AVAILABILITY
                    </button>
                    <button type="reset" class="clickBtn marL20" (click)="onExportClick()"
                        [disabled]="!showExportBtn">Export Results</button>
                </div>
                <app-loader-icon *ngIf="showLoader"></app-loader-icon>
                <div class="separateLineTop searchDataTable facilitatorSearchDataTable" #container>
                    <app-smart-data-grid *ngIf="showTable && totalRecords > 0" [sampleColumns]="sampleColumns"
                        [sampleData]="sampleData" [allowCheckbox]="allowCheckbox"
                        [allowSelectAllCheckbox]="allowSelectAllCheckbox" [iseventRegistered]="iseventRegistered"
                        [allowPagination]="allowPagination" [isClientSidePagination]="isClientSidePagination"
                        (informParentComponent)="onRowSelect($event)" (handlePageChangeEvent)="updateListData($event)"
                        [totalRecord]="totalRecords > 1000 ? 1000 : totalRecords" [pageSize]="pageSize"
                        (checkboxChangeEvent)="onCheckboxChange($event)"
                        (selectAllCheckbox)="onSelectAllCheckboxChange($event)"
                        (informCheckboxClick)="rowCheckboxClickEvent($event)" [onSearchClicked]="onSearchClicked">
                    </app-smart-data-grid>

                    <div class="backToTopBtn" *ngIf="showTable && totalRecords > 0" (click)="container.scrollTop = 0">
                        <i class="fa fa-arrow-circle-o-up"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-edit-facilitator [facilitatorDetails]="editFacilitatorsDetails" [masterData]="masterData"
        (updatedFacilitator)="updateFacilitator($event)"></app-edit-facilitator>
</div>
